import apisauce, { ApiOkResponse, ApiResponse } from 'apisauce';
import { Config, IApiError, ICenter, IProduct, ProductType, isApiError } from 'src/interfaces';

declare const config: Config;

class Api {
  apiBackend = apisauce.create({
    baseURL: config.apiService.webshop.api_endpoint + '/api',
    headers: {
      'Content-Type': 'application/json',
      'CENTER-ID': config.center,
    },
    timeout: 60000,
  });

  isResponseSuccessful = <T>(response: ApiResponse<IApiError | T>): response is ApiOkResponse<T> =>
    response.ok === true && response.data !== undefined && !isApiError(response.data);

  retrieveCenters = async () => {
    const result = await this.apiBackend.get<ICenter[] | IApiError>(`/centers`);

    if (this.isResponseSuccessful(result)) {
      return result.data;
    } else {
      console.log(`mock error retrieveCenters Error response: ${result.status}.`);
      return undefined;
    }
  };

  retrieveFilms = async (
    cinemaDateFrom: string,
    cinemaDateTo: string,
    performanceDateFrom: string,
    performanceDateTo: string,
    includeFilmCustomFields: boolean,
    includeFilmRelease: boolean,
    includeFilmReleaseCustomFields: boolean,
    center: string,
    language: string,
  ): Promise<ApiResponse<unknown> | undefined> => {
    const response = await this.apiBackend.get(
      '/films',
      {
        'cinemadate.from': cinemaDateFrom,
        'cinemadate.to': cinemaDateTo,
        'performancedate.from': performanceDateFrom,
        'performancedate.to': performanceDateTo,
        'include.film.customfields': includeFilmCustomFields,
        'include.filmrelease': includeFilmRelease,
        'include.filmrelease.customfields': includeFilmReleaseCustomFields,
        locale: language.toLowerCase(),
      },
      {
        headers: { 'center-oid': center },
      },
    );
    if (response.status === 200) {
      return response;
    } else {
      console.log(`mock error retrieveFilms Error response: ${response.status}.`);
      return undefined;
    }
  };

  retrieveProducts = async (center: string, filter: ProductType[] = []) => {
    const response = await this.apiBackend.get<IApiError | IProduct[]>(
      `/products`,
      {},
      { headers: { 'center-oid': center } },
    );

    if (this.isResponseSuccessful(response)) {
      const lookupSet = new Set(filter);
      return !filter.length ? response.data : response.data?.filter((p) => lookupSet.has(p.productType));
    } else {
      console.log(`mock error retrieveProducts Error response: ${response.status}.`);
      return undefined;
    }
  };

  retrieveConfiguration = async <T = unknown>(configurationKey: string) => {
    const response = await this.apiBackend.get<T | IApiError>(`/configurations/${configurationKey}`);

    if (!response.ok || !response.data || isApiError(response.data)) {
      console.log('mock error retrieveConfiguration Error result:', response);
      return undefined;
    }

    return response.data;
  };
}

const apiInstance = new Api();
export default apiInstance;
